// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import Firebase storage
import {
  getAuth,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAms6qek_6ynceHm4ODZd9MZYoUHy-JJBI",
  authDomain: "sbe-real-estate.firebaseapp.com",
  projectId: "sbe-real-estate",
  storageBucket: "sbe-real-estate.appspot.com",
  messagingSenderId: "656991904885",
  appId: "1:656991904885:web:50c6eb455a60782cfbc43c",
  measurementId: "G-CK9JFVL8JY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize Firebase storage
const auth = getAuth(app);

export { db, storage, auth };

// Set session persistence
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Session persistence set to session-only");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });
